import MediaQuery from 'react-responsive';
import Wave6Mobile from '../components/waves/wave6mobile';
import Wave4 from '../components/waves/wave4';
import VideoIntersection from '../components/videoIntersection';
import Key11 from '../components/keys/key11';
import Key11Tablet from '../components/keys/key11tablet';
import Key9Mobile from '../components/keys/key9mobile';
const comeToLifeVideo = '/ReactAssets/CustomerJourney/LIFE_MAIN.mp4';
const loadingPoster = '/ReactAssets/CustomerJourney/loading.gif';
function ComeToLife({ animate }) {
   return (
      <>
         <div className="cometolife bg-sand wave wave--top">
            <MediaQuery minWidth={768}>
               <Wave4 />
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Wave6Mobile />
            </MediaQuery>
            <div className="flex block1">
               <div className="col-1/2">
                  <h2>See your new home come to life</h2>
                  <p>
                     It’s amazing to watch your new home come to life and we
                     will be in touch with regular updates on the build
                     progress. We will even invite you to come and see your new
                     home while it’s under construction.
                  </p>
               </div>
            </div>
            <div className="flex block2">
               <div className="col-1/2 ">
                  <div class="content">
                     <p>
                        <strong>Your Progress Updates</strong> are when you’ll
                        receive regular build progress updates through the
                        website, app, emails and SMS. As well as our many{' '}
                        <strong>Quality Checks</strong> along the way, an
                        independent professional building inspection will also
                        happen. This is sign off from the relevant building
                        control authorities and a new home 10-year NHBC
                        Buildmark warranty granted, giving you peace of mind. A
                        week before you move in will be{' '}
                        <strong>Your Home Demonstration</strong>, where we will
                        take you around your new home to show you how everything
                        works. We’ll also answer any questions you may have. So
                        close now!
                     </p>
                  </div>
               </div>
               <div className="col-1/2 ">
                  <VideoIntersection
                     animate={animate}
                     src={comeToLifeVideo}
                     poster={loadingPoster}
                     loop
                  />
               </div>
            </div>
            {animate && (
               <>
                  <MediaQuery maxWidth={767}>
                     <Key9Mobile animate={animate} />
                  </MediaQuery>
                  <MediaQuery minWidth={768} maxWidth={1199}>
                     <Key11Tablet animate={animate} />
                  </MediaQuery>
                  <MediaQuery minWidth={1200}>
                     <Key11 animate={animate} />
                  </MediaQuery>
               </>
            )}
         </div>
      </>
   );
}

export default ComeToLife;
